import React from 'react';
import { useTranslation } from 'react-i18next';
import type { PreventionAlert } from 'types/preventionAlerts';
import { PreventionRow } from './PreventionRow';
import { RowSubtitle } from './DuePreventionsSection.styles';

export const GeriatricRow: React.FC<{ alert: PreventionAlert }> = ({ alert }) => {
  const { t } = useTranslation();
  const { segments } = alert.display;
  const doneCount = segments.filter((segment) => segment.status === 'done').length;
  const title = doneCount === 0 ? 'open' : doneCount === segments.length ? 'done' : 'partial';
  const parts = segments.map(
    (segment) =>
      `${t(`result.preventions.geriatric.${segment.key}`)} ${t(`result.preventions.geriatric.status.${segment.status}`)}`
  );

  return (
    <PreventionRow alert={alert} name={t(`result.preventions.geriatric.title.${title}`)}>
      <RowSubtitle>{`${parts.join(', ')}.`}</RowSubtitle>
    </PreventionRow>
  );
};
